/**
 * Quick Links Filter Interface
 * Strongly-typed filter form structure for filtering quick links
 *
 * IMPORTANT: Statuses, actionTypes, and usageLimitType now use numeric enum arrays
 * to match the API structure
 */

import { FormControl } from "@angular/forms";
import {
  QuickLinkActionType,
  QuickLinkStatus,
  UsageLimitType,
} from "./quick-link-list-item.interface";

/**
 * Filter Form Controls (Reactive Forms)
 * Uses numeric enum arrays for statuses, actionTypes, usageLimitType
 */
export interface IQuickLinksFilterControls {
  siteId: FormControl<number>;
  search: FormControl<string | null>;
  statuses: FormControl<QuickLinkStatus[]>; // Array of numeric enums (0, 1, 2)
  actionTypes: FormControl<QuickLinkActionType[]>; // Array of numeric enums (0, 1, 2, 3)
  usageLimitType: FormControl<UsageLimitType[]>; // Array of numeric enums (0, 1, 2) - currently unused
  page: FormControl<number>;
  pageSize: FormControl<number>;
  sortBy: FormControl<string | null>;
  sortDirection: FormControl<"asc" | "desc">;
}

/**
 * Filter Query Parameters (for API)
 * Matches API query parameter structure
 */
export interface QuickLinksFilter {
  siteId: number;
  search?: string;
  statuses?: QuickLinkStatus[]; // Array of numeric enums (0, 1, 2)
  actionTypes?: QuickLinkActionType[]; // Array of numeric enums (0, 1, 2, 3)
  usageLimitType?: UsageLimitType[]; // Array of numeric enums (0, 1, 2) - currently unused
  page: number;
  pageSize: number;
  orderBy?: string; // Field name to sort by (e.g., "createdUtc", "name", "id")
  order: "asc" | "desc";
}

/**
 * Default filter values
 * Note: sortBy changed from "createdAt" to "createdUtc" to match API field name
 */
export const DEFAULT_FILTER_VALUES = {
  page: 1,
  pageSize: 25,
  sortBy: "createdUtc", // Changed from "createdAt" to match API
  sortDirection: "desc" as "asc" | "desc",
};

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

// Filter option interfaces
export interface StatusFilterOption {
  value: QuickLinkStatus;
  label: string;
}

export interface ActionTypeFilterOption {
  value: QuickLinkActionType;
  label: string;
}

export interface UsageLimitFilterOption {
  value: UsageLimitType;
  label: string;
}
